
if (isProductPage) {
    var dataJudgeme = document.querySelector(".reviews__content .jdgm-rev-widg");
} else {
    var dataJudgeme = document.querySelector(".reviews__content .jdgm-revs-tab__content");
}


// console.log("D1: ", dataJudgeme);
if (dataJudgeme != undefined) {
    // var notes = getNotes(dataJudgeme);
    // if (!isNaN(notes.final)) {
    //     document.querySelector(".reviews__content [data-reviews-note]").innerHTML = notes.final+"/5";
    // }
    // document.querySelector(".reviews__content [data-reviews-total] span").innerHTML = notes.total;

    var notes = dataJudgeme.dataset.averageRating;
    if (notes != undefined) {
        if (notes == '5.00') { notes = '5'; }
        document.querySelector(".reviews__content [data-reviews-note]").innerHTML = notes +"/5";
        
        var notesNumbers = dataJudgeme.dataset.numberOfReviews;
        document.querySelector(".reviews__content [data-reviews-total] span").innerHTML = notesNumbers;   
    }

    getUsersInformations(dataJudgeme);
}

function getNotes(dataJudgeme) {
    var notesHtml = dataJudgeme.querySelectorAll("[data-frequency]");
    var currentRatesTmp = 0;
    var maxRatesTmp = 0;
    var notes = {
        "total": 0,
        "final": 0
    }
    notesHtml.forEach((note) => {
        var frequency = parseInt(note.dataset.frequency);
        var rating = note.dataset.rating;

        notes.total = notes.total + frequency;
        maxRatesTmp = maxRatesTmp + (frequency * 5);
        currentRatesTmp = currentRatesTmp + ( frequency * rating); 
    })
    notes.final = parseFloat(currentRatesTmp / maxRatesTmp * 5).toFixed(1);
    notes.final = notes.final.replace(".", ",").toString();
    // console.log("Notes: ", notes);

    return notes;
}

function getUsersInformations(dataJudgeme) {
    var authors = dataJudgeme.querySelectorAll(".jdgm-rev__author");
    var dates = dataJudgeme.querySelectorAll("[data-content]");
    var products = dataJudgeme.querySelectorAll(".jdgm-rev__prod-link");
    var ratings = dataJudgeme.querySelectorAll(".jdgm-rev__rating");
    var descriptions = dataJudgeme.querySelectorAll(".jdgm-rev__body");

    for (var i = 0; i <= 2; i++) {
        var currentBlock = document.querySelector("[data-reviews-block='"+i+"'");
        var formatedDateArray = dates[i]?.dataset.content.split(" ");
        
        if (formatedDateArray == undefined) {
            currentBlock.classList.add("hide");
            return true;
        }

        var formatedDate = formatedDateArray[0].split("-");
        var dateFr = formatedDate[2] + "/" + formatedDate[1] + "/" + formatedDate[0];
        
        currentBlock.querySelector("[data-reviews-username]").innerHTML = authors[i].innerHTML;
        currentBlock.querySelector("[data-reviews-date] span").innerHTML = dateFr;
        if (isProductPage) {
            currentBlock.querySelector("[data-reviews-selected-product]").innerHTML = document.querySelector("[data-product-title]").dataset.productTitle;
        } else {
            currentBlock.querySelector("[data-reviews-selected-product]").innerHTML = products[i].innerHTML;
        }
        currentBlock.querySelector("[data-reviews-stars]").innerHTML = ratings[i].innerHTML;
        currentBlock.querySelector("[data-reviews-description]").innerHTML = descriptions[i].innerHTML;
    }
}